import { useIsLoggedInQuery } from 'auth/hooks'
import { useSubscriptionIdsQuery } from '@repo/cf-user/hooks/use-user-data'
import { useStudioSiteDataQuery } from '@repo/studio-hooks-site-data/use-studio-site-data'

import { resolveUndoCancellationBannerQuery } from './resolve-undo-cancellation-banner-query'

export function useUndoCancellationBannerQuery() {
  const isLoggedInQuery = useIsLoggedInQuery()
  const pendingCancelSubscriptionIdQuery = useStudioSiteDataQuery({
    select: data => data.siteData.undoCancelationBanner?.subscriptionId,
  })
  const subscriptionIdsQuery = useSubscriptionIdsQuery()

  return resolveUndoCancellationBannerQuery({
    isAuthPending: isLoggedInQuery.isPending,
    isLoggedIn: isLoggedInQuery.data === true,
    isSiteDataPending: pendingCancelSubscriptionIdQuery.isPending,
    isSubscriptionIdsPending: subscriptionIdsQuery.isPending,
    pendingCancelSubscriptionId: pendingCancelSubscriptionIdQuery.data,
    subscriptionIds: subscriptionIdsQuery.data,
  })
}
